/**
 * Map and location utility functions
 * Used for generating map links to different navigation apps
 */

/**
 * Generate map URLs for different navigation apps
 * @param {string} location - Location address or name
 * @returns {Object} Object containing URLs for Google Maps, Apple Maps, and Waze
 */
export const getMapUrls = (location) => {
  const encoded = encodeURIComponent(location)
  return {
    google: `https://www.google.com/maps/search/?api=1&query=${encoded}`,
    apple: `https://maps.apple.com/?q=${encoded}`,
    waze: `https://waze.com/ul?q=${encoded}`
  }
}
